function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '../../configs';
/*
|---------------------------------------------------------------------
| Toolbar User Component
|---------------------------------------------------------------------
|
| Quickmenu for user menu shortcuts on the toolbar
|
*/
import tasks from '@/js/tasks';
import 'firebase/auth';
import 'firebase/messaging';
import { ROLES_LIST } from '@/js/constants';
import { GA_EVENTS } from '@/js/constants';
import { computed, watch } from '@vue/composition-api';
import { mapState } from 'vuex';
import whitelist_service from '@/apps/data-platform/services/master_data/whitelist_service';

// import firebaseMessaging from '../../plugins/firebase'

export default {
  data: function data() {
    return {
      menu: config.toolbar.user,
      navigation: config.navigation,
      domain_actual: ''
    };
  },
  computed: _objectSpread({}, mapState('data-platform', ['domains_optional', 'orgs'])),
  created: function created() {
    // console.log("asd", this.navigation)
    console.log(this.domains_optional);
    this.domain_actual = window.userInfo.domain;
  },
  mounted: function mounted() {},
  methods: {
    getDomainUser: function getDomainUser() {
      return window.userInfo.domain;
    },
    onLogout: function onLogout() {
      // logout and reload
      if (this.$gtm.enabled() && window.dataLayer) {
        console.log("logout");
        window.dataLayer.push({
          event: GA_EVENTS.LOGOUT,
          eventName: GA_EVENTS.LOGOUT,
          hash_email: this.stringToHash(window.userInfo.email),
          domain: window.userInfo.domain,
          type: 'google'
          // further parameters
        });
      }
      var self = this;
      tasks.logoutApplication(function () {
        // console.log('callback: go to login')
        self.$router.push('/ContLogin');
      });
    },
    onSelectDomain: function onSelectDomain(event) {
      console.log("select domain", event);
      whitelist_service.change_my_domain(this.domain_actual).then(function (response) {
        if (response && response.success === true) {
          console.log("domain changed");
          window.location.reload();
        } else {
          tasks.toast.warning('No se pudo cambiar el dominio');
        }
      });
    },
    onCopy: function onCopy(email) {
      navigator.clipboard.writeText(email);
    },
    getRoles: function getRoles() {
      var _this = this;
      var _menu = Object.assign([], this.navigation.menu).filter(function (x) {
        return x.pantallaInicial;
      });
      //_menu.shift()
      var arrayStrings = ['data_platform', 'audience', 'attribute', 'insights', 'ml', 'dataops'];
      _menu.forEach(function (x) {
        x.name_i18n = _this.traductor(x.key);
      });
      _menu.forEach(function (x, index) {
        x.id = arrayStrings[index];
      });
      var array = this.userInfo.userRoles;
      var dictionary = ROLES_LIST;
      var filteredKeys = Object.keys(dictionary).filter(function (key) {
        return array.includes(dictionary[key]);
      });
      var separatedRoles = {
        data_platform: [],
        audience: [],
        attribute: [],
        insights: [],
        dataops: [],
        ml: []
      };
      var prefixes = ['AUDIENCE_', 'ATTRIBUTE_', 'INSIGHTS_', 'ML_', 'DATAOPS_'];
      var _iterator = _createForOfIteratorHelper(filteredKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var role = _step.value;
          var found = false;
          var _iterator2 = _createForOfIteratorHelper(prefixes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var prefix = _step2.value;
              if (role.startsWith(prefix)) {
                separatedRoles[prefix.toLowerCase().slice(0, -1)].push(ROLES_LIST[role]);
                found = true;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (!found) {
            separatedRoles.data_platform.push(ROLES_LIST[role]);
          }
        }
        // console.log("lengt", _menu.length)
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var i = 0; i < _menu.length; i++) {
        var id = _menu[i].id;
        if (separatedRoles[id]) {
          _menu[i].roles_user = separatedRoles[id];
        }
      }
      // console.log("final: ", _menu)
      return _menu;
    }
  }
};